import { useCallback, useEffect, useState } from "react";
import { useAuthSession } from "../auth/useAuthSession.ts";
import { getBrowserClient } from "../supabase/browser.ts";
export interface PowerballPrediction {
 id:string;fixture_id:string;match_name:string;league:string;country_code:string|null;kickoff_at:string;market:string;pick:string;odds:number;
 review_state:"REVIEW_PENDING";booking_available:false;
}
export interface PowerballPredictionTier {tier:string;status:string;target_legs:number;selections:PowerballPrediction[];refresh:{state:string;checked_at:string|null;candidate_count:number}|null;booking_available:false}
export interface PowerballPredictionFeed {as_of:string;session_date:string;tiers:Record<string,PowerballPredictionTier>}
export function usePowerballPredictionFeed(enabled=true){
 const [tick,setTick]=useState(0);const refetch=useCallback(()=>setTick(x=>x+1),[]);
 const {user}=useAuthSession();const [snapshot,setSnapshot]=useState<{owner:string;data:PowerballPredictionFeed}|null>(null);const [error,setError]=useState(false);
 useEffect(()=>{
  if(!user||!enabled){setSnapshot(null);setError(false);return;}
  let cancelled=false,working=false;
  const refresh=async()=>{if(working)return;working=true;try{
   const r=await(getBrowserClient().rpc as any)("get_pb_prediction_feed");
   if(cancelled)return;
   if(r.error||!r.data?.tiers){setSnapshot(null);setError(true);return;}
   setSnapshot({owner:user.id,data:r.data});setError(false);
  }catch{if(!cancelled){setSnapshot(null);setError(true);}}finally{working=false;}};
  void refresh();const timer=window.setInterval(refresh,60_000);
  return()=>{cancelled=true;window.clearInterval(timer);};
 },[user?.id,enabled,tick]);
 return {feed:enabled&&snapshot&&snapshot.owner===user?.id?snapshot.data:null,error,refetch};
}
